import React from "react";

const contacts = [
  {
    name: "Anders Tveit",
    role: "Daglig leder",
    phone: "+47 916 97 897",
    email: "anders.tveit@dekkpartner.no",
    image: "/img/anders.jpg",
  },
  {
    name: "Malin Lauritsen",
    role: "Arrangementansvarlig",
    phone: "+47 920 21 294",
    email: "malin.lauritsen@dekkpartner.no",
    image: "/img/malin.jpg",
  },
  {
    name: "Kristoffer Solum",
    role: "Teknisk ansvarlig",
    phone: "+47 903 68 904",
    email: "kristoffer.solum@dekkpartner.no",
    image: "/img/kristoffer.jpg",
  },
  {
    name: "Sverre Gaaserud",
    role: "Tur-leder",
    phone: "+47 918 00 310",
    email: "sverre@360-grader.no",
    image: "/img/sverre.jpg",
  },
  {
    name: "Agnieszka Sidorowicz",
    role: "Lokal guide",
    phone: "+48 501 37 38 66",
    image: "/img/elin.jpg",
  },
];

export default function Contact() {
  return (
    <div style={{ padding: "2rem", maxWidth: "1100px", margin: "0 auto" }}>
      {/* 🚨 Nødnummer */}
    <div
        style={{
        background: "#adb6bf",
        border: "1px solid #adb6bf",
        borderRadius: "12px",
        padding: "1.5rem",
        marginBottom: "2rem",
        textAlign: "center",
        color: "#06111e",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        }}
    >
        <h3 style={{ marginBottom: "1rem" }}>🚨 Nødnummer i Polen</h3>
        <p style={{ margin: "0.5rem 0" }}>
        <strong>Alle nødetater:</strong>{" "}
        <a href="tel:112" style={{ color: "#06111e", textDecoration: "underline" }}>
            112
        </a>
        </p>
        <p style={{ margin: "0.5rem 0" }}>
        <strong>Ambulanse:</strong>{" "}
        <a href="tel:999" style={{ color: "#06111e", textDecoration: "underline" }}>
            999
        </a>
        </p>
        <p style={{ margin: "0.5rem 0" }}>
        <strong>Politi:</strong>{" "}
        <a href="tel:997" style={{ color: "#06111e", textDecoration: "underline" }}>
            997
        </a>
        </p>
    </div>


      <h2 style={{ marginBottom: "2rem", textAlign: "center" }}>Kontaktpersoner</h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "2rem",
          justifyContent: "center",
        }}
      >
        {contacts.map((person, idx) => (
          <div
            key={idx}
            style={{
              flex: "1 1 250px",
              maxWidth: "300px",
              backgroundColor: "#f9f9f9",
              borderRadius: "12px",
              padding: "1.5rem",
              textAlign: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              transition: "transform 0.2s",
            }}
          >
            <img
              src={person.image}
              alt={person.name}
              onError={(e) =>
                (e.currentTarget.src = `https://placehold.co/200x200?text=${encodeURIComponent(person.name)}`)
              }
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: "1rem",
              }}
            />
            <h3 style={{ marginBottom: "0.25rem" }}>{person.name}</h3>
            <p style={{ color: "#555", marginBottom: "1rem" }}>{person.role}</p>
            <p>
              <strong>📞</strong>{" "}
              <a href={`tel:${person.phone}`} style={{ color: "#002d72", textDecoration: "none" }}>
                {person.phone}
              </a>
            </p>
            <p>
              <strong>✉️</strong>{" "}
              <a href={`mailto:${person.email}`} style={{ color: "#002d72", textDecoration: "none" }}>
                {person.email}
              </a>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

